import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "fcon_add_trigger"
};
var _hoisted_2 = {
  "class": "fcon_provider_selectors"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["title", "src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("h3", null, "Select Action", -1 /* HOISTED */)), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.all_actions, function (provider, providerKey) {
    return _openBlock(), _createElementBlock("li", {
      key: providerKey,
      "class": _normalizeClass({
        fcon_active_trigger: providerKey == $data.action.action_provider
      }),
      onClick: function onClick($event) {
        return $options.changeActionProvider(providerKey);
      }
    }, [_createElementVNode("img", {
      title: provider.title,
      src: provider.logo
    }, null, 8 /* PROPS */, _hoisted_4)], 10 /* CLASS, PROPS */, _hoisted_3);
  }), 128 /* KEYED_FRAGMENT */))]), this.action.action_provider ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    style: {
      "margin-top": "20px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.actionSuccess();
    }),
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[1] || (_cache[1] = [_createTextVNode("Continue")]);
    }),
    _: 1 /* STABLE */
  })) : _createCommentVNode("v-if", true)]);
}